import { FundLiterature } from 'model/KidsHub';
import { useI18n } from 'next-localization';
import { useMemo } from 'react';

export const useTableRow = (row: FundLiterature, selectedShareClass: number) => {
  const { t } = useI18n();
  const placeholder = t('noResultsMessage');
  const shareClassOptions = useMemo(
    () =>
      row.shareclasses.map((value, i) => ({
        label: value.shareclassName,
        value: i,
      })),
    [row.shareclasses]
  );
  const showDownloadButton =
    row.shareclasses.length > 0 && !!row.shareclasses[selectedShareClass].kid;
  const downloadlink = {
    value: {
      href: row.shareclasses[selectedShareClass]?.kid?.documentURI,
      linktype: 'internal',
      target: '_blank',
    },
  };
  return { placeholder, shareClassOptions, showDownloadButton, downloadlink };
};
